export const allowedFileTypes = ['.jpg', '.jpeg', '.png', '.pdf', '.heif', '.heic']

export function getProductId(partialSerial: string) {
  const absoluteIds = ['UZ4-EU', 'WP4-EU', 'VH1-EU', 'VK7-EU', 'VZ2-EU', 'VK6-EU', 'Z6R-EU']
  const v8Ids = ['Z6E-EU', '6DD-EU']
  const v12Ids = ['T4M-EU', '7BT-EU']
  const v11Ids = ['Z6Z-EU', 'W7Z-EU', '6DF-EU']
  const v15Ids = ['Z5W-EU', '4DY-EU', 'Z5X-EU', '5DJ-EU']
  const submarineIds = ['3BR-EU']
  const gen5Ids = ['Z5S-EU', 'Z5T-EU']
  const vis360Ids = ['H8T-EU', '4GF-EU']
  const washg1 = ['1GC']
  // V16 Piston Animal product list:
  //   Dyson V16 Piston Animal
  //   Dyson V16 Piston Animal Submarine™
  //   Dyson V16 Piston Animal + Detailed Cleaning Kit
  //   Dyson V16 Piston Animal Submarine™ (Soft Bundle)
  const pistonIds = ['7RD-EU', '7RE-EU', '7RF-EU', '7RE-EU']
  // Airwrap Co-anda2x™
  const coanda2xIds = ['5PC-EU', '6PS-EU', '5PW-EU', '7PA-EU', '6UT-EU', '7UJ-EU']
  // Airwrap i.d.™
  const airwrapidIds = ['9SN-EU', '1TD-EU', '1TP-EU', '2TH-EU', '5UN-EU', '6UF-EU']

  if (v12Ids.includes(partialSerial)) {
    return 'v12'
  }

  if (v8Ids.includes(partialSerial)) {
    return 'v8'
  }

  if (absoluteIds.includes(partialSerial)) {
    return 'absolute'
  }

  if (v11Ids.includes(partialSerial)) {
    return 'v11'
  }

  if (gen5Ids.includes(partialSerial)) {
    return 'gen5'
  }

  if (v15Ids.includes(partialSerial)) {
    return 'v15'
  }

  if (submarineIds.includes(partialSerial)) {
    return 'submarine'
  }

  if (vis360Ids.includes(partialSerial)) {
    return 'vis360'
  }

  if (washg1.includes(partialSerial)) {
    return 'washg1'
  }

  if (pistonIds.includes(partialSerial)) {
    return 'piston'
  }

  if (coanda2xIds.includes(partialSerial)) {
    return 'coanda2x'
  }

  if (airwrapidIds.includes(partialSerial)) {
    return 'airwrapid'
  }

  return undefined
}

export const validate = {
  email:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  serialNumber: {
    at: /^(3BR|Z5S|Z5T|7RD|7RE|7RF|7RE|5PC|6PS|5PW|7PA|6UT|7UJ|9SN|1TD|1TP|2TH|5UN|6UF)-EU-[A-HJ-KM-NPR-Z][A-HJ-KM-N][A-Z0-9]{5}[A-Z]$/,
    de: /^(3BR|Z5S|Z5T|7RD|7RE|7RF|7RE|5PC|6PS|5PW|7PA|6UT|7UJ|9SN|1TD|1TP|2TH|5UN|6UF)-EU-[A-HJ-KM-NPR-Z][A-HJ-KM-N][A-Z0-9]{5}[A-Z]$/,
    fr: /^(Z5W|4DY|Z5X|5DJ|3BR|Z5S|Z5T|H8T|4GF)-EU-[A-HJ-KM-NPR-Z][A-HJ-KM-N][A-Z0-9]{5}[A-Z]$/,
    it: /^(3BR|Z5S|Z5T|Z5W|Z5X)-EU-[A-HJ-KM-NPR-Z][A-HJ-KM-N][A-Z0-9]{5}[A-Z]$/,
    unieuro: /^(3BR|Z5S|Z5T)-EU-[A-HJ-KM-NPR-Z][A-HJ-KM-N][A-Z0-9]{5}[A-Z]$/,
  },
  fileUpload: ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf', 'image/heif', 'image/heic'],
}

export const allowedCountries = [
  { code: 'AT', en: 'Austria', de: 'Österreich', fr: 'Autriche', it: 'Austria' },
  { code: 'BE', en: 'Belgium', de: 'Belgien', fr: 'Belgique', it: 'Belgio' },
  { code: 'BG', en: 'Bulgaria', de: 'Bulgarien', fr: 'Bulgarie', it: 'Bulgaria' },
  { code: 'HR', en: 'Croatia', de: 'Kroatien', fr: 'Croatie', it: 'Croazia' },
  { code: 'CY', en: 'Cyprus', de: 'Zypern', fr: 'Chypre', it: 'Cipro' },
  { code: 'CZ', en: 'Czech Republic', de: 'Tschechien', fr: 'République tchèque', it: 'Repubblica Ceca' },
  { code: 'DK', en: 'Denmark', de: 'Dänemark', fr: 'Danemark', it: 'Danimarca' },
  { code: 'EE', en: 'Estonia', de: 'Estland', fr: 'Estonie', it: 'Estonia' },
  { code: 'FI', en: 'Finland', de: 'Finnland', fr: 'Finlande', it: 'Finlandia' },
  { code: 'FR', en: 'France', de: 'Frankreich', fr: 'France', it: 'Francia' },
  { code: 'DE', en: 'Germany', de: 'Deutschland', fr: 'Allemagne', it: 'Germania' },
  { code: 'GR', en: 'Greece', de: 'Griechenland', fr: 'Grèce', it: 'Grecia' },
  { code: 'HU', en: 'Hungary', de: 'Ungarn', fr: 'Hongrie', it: 'Ungheria' },
  { code: 'IS', en: 'Iceland', de: 'Island', fr: 'Islande', it: 'Islanda' },
  { code: 'IE', en: 'Ireland', de: 'Irland', fr: 'Irlande', it: 'Irlanda' },
  { code: 'IT', en: 'Italy', de: 'Italien', fr: 'Italie', it: 'Italia' },
  { code: 'LV', en: 'Latvia', de: 'Lettland', fr: 'Lettonie', it: 'Lettonia' },
  { code: 'LI', en: 'Liechtenstein', de: 'Liechtenstein', fr: 'Liechtenstein', it: 'Liechtenstein' },
  { code: 'LT', en: 'Lithuania', de: 'Litauen', fr: 'Lituanie', it: 'Lituania' },
  { code: 'LU', en: 'Luxembourg', de: 'Luxemburg', fr: 'Luxembourg', it: 'Lussemburgo' },
  { code: 'MT', en: 'Malta', de: 'Malta', fr: 'Malte', it: 'Malta' },
  { code: 'NL', en: 'Netherlands', de: 'Niederlande', fr: 'Pays-Bas', it: 'Paesi Bassi' },
  { code: 'NO', en: 'Norway', de: 'Norwegen', fr: 'Norvège', it: 'Norvegia' },
  { code: 'PL', en: 'Poland', de: 'Polen', fr: 'Pologne', it: 'Polonia' },
  { code: 'PT', en: 'Portugal', de: 'Portugal', fr: 'Portugal', it: 'Portogallo' },
  { code: 'RO', en: 'Romania', de: 'Rumänien', fr: 'Roumanie', it: 'Romania' },
  { code: 'SK', en: 'Slovakia', de: 'Slowakei', fr: 'Slovaquie', it: 'Slovacchia' },
  { code: 'SI', en: 'Slovenia', de: 'Slowenien', fr: 'Slovénie', it: 'Slovenia' },
  { code: 'ES', en: 'Spain', de: 'Spanien', fr: 'Espagne', it: 'Spagna' },
  { code: 'SE', en: 'Sweden', de: 'Schweden', fr: 'Suède', it: 'Svezia' },
]

export const fileTypes = {
  serialNumber: 'serial_number',
  receipt: 'receipt',
}

export const dysonPremiumOfferPrefixes = [
  '5SX',
  'D1G',
  'P1Y',
  'P1Z',
  'T5N',
  'P5S',
  'P2T',
  'G3K',
  'G5D',
  'G4E',
  'G5E',
  'G5F',
  'G4F',
  'H5T',
  'H5U',
  'H4N',
  'H5V',
  'H9U',
  'H5W',
  '6DF',
  'W7W',
  'W7X',
  'W7Y',
  'W8A',
  'W8J',
  'W8K',
  'Z3Y',
  'Z3Z',
  'Z6Z',
  'Z6W',
  '6DG',
  '6DM',
  '6DN',
  '5FZ',
  '6FA',
  'G2R',
  'G2S',
  'H3F',
  'H3Y',
  'H3G',
  'H3X',
  'H3W',
  'N9H',
  'N9J',
  'W7F',
  'C1Y',
  'C1Z',
  'C1X',
  'D1E',
  'D2S',
  'D2V',
  'D2T',
  'D2W',
  'D1F',
  'D1H',
  'D2U',
  'D2X',
  'E6X',
  'E6Y',
  'E6Z',
  'E6P',
  'G3E',
  'H2U',
  'F6B',
  'N8N',
  'N5D',
  'S2G',
  'N5B',
  'P5Y',
  'S3D',
  'S3F',
  'S3H',
  'S3J',
  'S3K',
  'S3E',
  'T8G',
  'T8W',
  'U5A',
  'U5B',
  'U5C',
  'Y7P',
  'Y7R',
  '7BS',
  '7BT',
  '8CW',
  '4DX',
  '4DZ',
  '6DH',
  '7MR',
  '3ET',
  'U3E',
  '5DA',
  'Z5X',
  'Z5Z',
  'Z6A',
  '4DY',
  '5DJ',
  '5DM',
  '5DN',
  '5DP',
  'N3G',
  'N3H',
  'N3J',
  'N3K',
  'N3R',
  'N3S',
  'N3U',
  'N3Z',
  'N4A',
  'N4E',
  'U3B',
  'U3C',
  'U3G',
  'U3H',
  'U3J',
  'U3N',
  'Y7E',
  'Y7F',
  'Y7K',
  'Z2T',
  'Z2S',
  'Z3D',
  'Z5S',
  'Z5T',
  'Z5U',
  'Z5V',
  '9SN',
  '1TD',
  '1TP',
  '2TH',
  '5UN',
  '6UF',
]

export function isPremiumOfferPrefix(input: string): boolean {
  return dysonPremiumOfferPrefixes.some(prefix => input?.toUpperCase().startsWith(prefix))
}
